import { uiFormat, useAccountLocale } from '../../i18n';
import { useEffect, useRef } from 'react';
/** Локальное прослушивание образца до согласия: файл не покидает браузер. */
export function SampleAudio({ file }: {
    file: File;
}) {
    useAccountLocale(); // смена языка профиля перерисовывает подпись плеера
    const audio = useRef<HTMLAudioElement>(null);
    useEffect(() => {
        const url = URL.createObjectURL(file);
        const element = audio.current;
        if (element)
            element.src = url;
        return () => {
            element?.pause();
            if (element) {
                element.removeAttribute('src');
                element.load();
            }
            URL.revokeObjectURL(url);
        };
    }, [file]);
    return <audio ref={audio} controls preload="none" aria-label={uiFormat('Образец {0}', file.name)}/>;
}
